import type { ReactNode } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../form';
import { Input } from '../input';
import { Text } from '@folio/components/ui/text';

export type FormTextInputProps<TFields extends FieldValues> = {
  control: Control<TFields>;
  label?: ReactNode;
  type?: string;
  name: Path<TFields>;
  placeholder?: string;
  description?: ReactNode;
  required?: boolean;
  autoComplete?: string;
  disabled?: boolean;
};

export const FormTextInput = <TFields extends FieldValues>({
  control,
  label,
  name,
  placeholder,
  description,
  type,
  required,
  autoComplete,
  disabled,
}: FormTextInputProps<TFields>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {!!label && (
            <FormLabel>
              {label}{' '}
              {required && (
                <Text inline tone="destructive">
                  *
                </Text>
              )}
            </FormLabel>
          )}
          <FormControl>
            <Input
              placeholder={placeholder}
              type={type}
              autoComplete={autoComplete}
              disabled={disabled}
              {...field}
            />
          </FormControl>
          {!!description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
